<div class="modal-backdrop" *ngIf="aberto">
  <div class="modal-content">
    <h5>Editar Status</h5>
    <label for="statusSelect" class="form-label">Status</label>
    <select
      id="statusSelect"
      [(ngModel)]="novoStatus"
      class="form-select"
      [ngModelOptions]="{ standalone: true }"
    >
      <option [value]="1">Ativo</option>
      <option [value]="0">Inativo</option>
    </select>
    <div class="actions">
      <button class="btn btn-success btn-sm" (click)="salvarStatus()">
        Salvar
      </button>
      <button class="btn btn-primary btn-sm" (click)="fechar.emit()">
        Cancelar
      </button>
    </div>
  </div>
</div>
